import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@shared/utils";

interface CategoryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Path to the SVG icon in public folder */
  iconSrc: string;
  /** Label shown below the icon */
  label: string;
  /** Size of the icon in pixels */
  iconSize?: number;
  /** Whether this category is currently selected */
  isSelected?: boolean;
  hasActiveSelection?: boolean;
  children?: ReactNode;
}

/**
 * Category button atom.
 * Displays an SVG icon with a label below it (e.g., Deportes, Fiestas).
 */
export function CategoryButton({
  iconSrc,
  label,
  iconSize = 55,
  isSelected = false,
  hasActiveSelection = false,
  className,
  ...props
}: CategoryButtonProps) {
  const isActive = isSelected || !hasActiveSelection;
  return (
    <button
      className={cn(
        "flex flex-col items-center gap-2 bg-transparent border-none cursor-pointer transition-opacity hover:opacity-80",
        className,
      )}
      {...props}
    >
      <img
        src={iconSrc}
        alt={label}
        style={{ width: iconSize, height: iconSize }}
        className={cn(
          "object-contain transition-opacity",
          isActive ? "opacity-100" : "opacity-40",
        )}
      />
      <span className={cn("text-h4 font-medium transition-colors text-white")}>
        {label}
      </span>
    </button>
  );
}
